<template>
  <div class="breadcrumbs">
    <template v-for="(crumb, index) in crumbs" :key="crumb.title + index">
      <NuxtLink v-if="crumb?.url && crumb?.title" :to="localePath(crumb.url)" class="ul">
        {{ crumb.title }}
      </NuxtLink>
      <span v-if="index !== crumbs.length - 1" :key="crumb.title + index + 'divider'"> / </span>
    </template>
  </div>
</template>

<script setup lang="ts">
type Crumb = {
  url: string;
  title: string;
};

const localePath = useLocalePath();

defineProps({
  crumbs: {
    type: Array as () => Crumb[],
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.breadcrumbs {
  font-size: 0.875rem;
  margin-bottom: 1rem;
  text-transform: capitalize;
}

@include local-mixins.desktop {
  .breadcrumbs {
    margin-bottom: 1.5rem;
  }
}
</style>
